import { render, staticRenderFns } from "./ProfileHeaderBackground.vue?vue&type=template&id=a7615e52&scoped=true&"
import script from "./ProfileHeaderBackground.vue?vue&type=script&lang=ts&"
export * from "./ProfileHeaderBackground.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileHeaderBackground.vue?vue&type=style&index=0&id=a7615e52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7615e52",
  null
  
)

export default component.exports